// extracted by mini-css-extract-plugin
export default {"root":"AuqGVYku","title":"SDztXUTI","closeButton":"lVydEW4b"};